// extracted by mini-css-extract-plugin
module.exports = {"login":"LoginForm_login__3iFBG","loginForm":"LoginForm_loginForm__2mhqc","button":"LoginForm_button__37TVs","logo":"LoginForm_logo__3dt8J"};